import {ChangeDetectorRef, Component, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {NavigateService, FormService, LoaderService, LangService} from 'ngx-satoris';
import {PaperSize, PrintSettingsDetails, AllDocumentsPrintType, PrintableDocuments} from 'src/app/shared/models/print';
import {ApiService} from 'src/app/shared/services/api.service';
import {PrintService} from 'src/app/shared/services/print.service';
import {enumStringToArrayObject} from 'src/app/shared/utils/enumToArrayObject';

declare const window: any;

@Component({
  selector: 'app-print-settings',
  templateUrl: './print-settings.component.html',
  styleUrl: './print-settings.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class PrintSettingsComponent {

  form: FormGroup;
  submitted: boolean;
  printDocumentSelected : AllDocumentsPrintType | null = null;
  paperSizeSelectOptions = enumStringToArrayObject(PaperSize);
  printerList: any;

  constructor(public nav: NavigateService,
    public forms: FormService,
    private formBuilder: FormBuilder,
    public api: ApiService,
    private print: PrintService,
    private loader: LoaderService,
    private lang: LangService,
    private cdr: ChangeDetectorRef) {
    this.modifyPrinterList();
  }

  setForm(documentName: AllDocumentsPrintType) {
    this.form = this.formBuilder.group({
      defaultPrinter: [this.print.printDocumentsOptions?.[documentName]?.defaultPrinter ? this.print.printDocumentsOptions?.[documentName]?.defaultPrinter : ''],
      colorMode: [this.print.printDocumentsOptions?.[documentName]?.colorMode ? this.print.printDocumentsOptions?.[documentName]?.colorMode : false],
      paperSize: [this.print.printDocumentsOptions?.[documentName]?.paperSize ? this.print.printDocumentsOptions?.[documentName]?.paperSize : PaperSize.A4]
    });
  }

  submitForm(documentName: AllDocumentsPrintType) {
    this.submitted = true;
    const existingPrintSettings = this.print.printDocumentsOptions || {};
    const updatedDocumentSettings : PrintSettingsDetails = {
      defaultPrinter: this.form.get('defaultPrinter')?.value,
      colorMode: this.form.get('colorMode')?.value,
      paperSize: this.form.get('paperSize')?.value
    };
    const updatedPrintSettings = {
      ...existingPrintSettings,
      [documentName]: updatedDocumentSettings
    };
    this.print.setPrintSettings(updatedPrintSettings);
    this.loader.loading(true, {type: 'valid', custom: {innerHtml: this.lang.transform('print.settings.success', {documentName: this.lang.transform('DYN.' + documentName)})}
    }).then(() => {
      this.printDocumentSelected = null;
      this.print.printDocumentsOptions = updatedPrintSettings;
    });
  }

  selectDocument(documentName: AllDocumentsPrintType) {
    this.printDocumentSelected = documentName;
    this.setForm(documentName);
  }

  goBack() {
    this.printDocumentSelected ? this.printDocumentSelected = null : this.nav.to('my-account');
  }

  reloadPrinterList() {
    return this.print.detectPrinterList().then(() => {
      this.modifyPrinterList();
      this.cdr.detectChanges();
      if(this.printDocumentSelected) {
        this.setForm(this.printDocumentSelected);
      }
    });
  }

  modifyPrinterList() {
    this.printerList = this.print.printerList.map((printer: any) => {
      const isOffline = window.electron.addon.printerStatusOffline && window.electron.addon.printerStatusOffline(printer.name) === PrinterStatus.PRINTER_OFFLINE;
      return {
        name: printer.name + (isOffline ? ' (Offline)' : ''),
        value: printer.value
      };
    });
  }

  protected readonly ListDocumentsPrintable = PrintableDocuments;
}
